import { render, staticRenderFns } from "./comCouponCenter.vue?vue&type=template&id=61778daf&scoped=true"
import script from "./comCouponCenter.vue?vue&type=script&lang=js"
export * from "./comCouponCenter.vue?vue&type=script&lang=js"
import style0 from "./comCouponCenter.vue?vue&type=style&index=0&id=61778daf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61778daf",
  null
  
)

export default component.exports